/**
 * TPRA Home Dashboard Main Component
 * Container for all dashboard sections with independent loading/error states
 */

import { useRef, useState, useCallback } from "react";
import { DashboardHeader } from "./components/DashboardHeader";
import { SummaryCards } from "./components/SummaryCards";
import { AssessmentPipeline } from "./components/AssessmentPipeline";
import { RiskHeatmap } from "./components/RiskHeatmap";
import { FindingsSummary } from "./components/FindingsSummary";
import { TasksSection } from "./components/TasksSection";
import { RecentEventsSection } from "./components/RecentEventsSection";

export const Dashboard = () => {
  // Refs for scroll targets
  const tasksRef = useRef<HTMLDivElement>(null);
  const eventsRef = useRef<HTMLDivElement>(null);

  // State for showing all tasks
  const [showAllTasks, setShowAllTasks] = useState(false);

  // Scroll handlers
  const handleScrollToTasks = useCallback(() => {
    setShowAllTasks(true);
    // Small delay to allow re-render with new data
    setTimeout(() => {
      tasksRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  }, []);

  const handleScrollToEvents = useCallback(() => {
    eventsRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return (
    <div className="flex flex-col gap-6">
      {/* Welcome Header */}
      <DashboardHeader />

      {/* Summary Cards */}
      <SummaryCards onScrollToTasks={handleScrollToTasks} onScrollToEvents={handleScrollToEvents} />

      {/* Assessment Pipeline */}
      <AssessmentPipeline />

      {/* Charts Row - Phase 3 & 4 */}
      <div className="grid grid-cols-2 gap-6">
        <RiskHeatmap />
        <FindingsSummary />
      </div>

      {/* Bottom Row - Phase 5 & 6 */}
      <div className="grid grid-cols-2 gap-6">
        <div ref={tasksRef}>
          <TasksSection showAll={showAllTasks} />
        </div>
        <div ref={eventsRef}>
          <RecentEventsSection />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
